// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3x1Bs","newExpiryDate":"styles_newExpiryDate__N0bVv","footer":"styles_footer__t4usB"};